import { render, staticRenderFns } from "./CommunityFeed.vue?vue&type=template&id=3274f462&"
import script from "./CommunityFeed.vue?vue&type=script&lang=js&"
export * from "./CommunityFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports